/*
 * Theaterish Kit (ConvertKit) opt-in handler.
 * Progressive enhancement for any `form[data-th-kit]`: posts to the Kit form
 * endpoint and swaps in a sibling `[data-th-kit-success]` card inline. Without JS
 * the form posts to Kit directly (opens Kit's confirmation). Handles any number of
 * opt-in forms on a page via event delegation; binds once.
 */
(function () {
  if (window.__thKitBound) return;
  window.__thKitBound = true;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-th-kit]');
    if (!form) return;
    e.preventDefault();

    var email = form.querySelector('[name="email_address"]');
    if (email && !email.value) { email.focus(); return; }

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var success = form.parentElement && form.parentElement.querySelector('[data-th-kit-success]');

    fetch(form.action, { method: 'POST', body: new FormData(form), mode: 'no-cors' })
      .catch(function () {})
      .then(function () {
        if (btn) btn.removeAttribute('aria-busy');
        form.hidden = true;
        // Inline display:none guarantees the form hides even when a class rule
        // (e.g. .th-optin__form/.th-fbar__form { display:flex }) would otherwise
        // out-specify the [hidden] attribute and keep it visible.
        form.style.display = 'none';
        if (success) success.hidden = false;
      });
  });
})();
